export default {
    props: {
        connectors: {
            type: Array,
            default: undefined,
            kComposite: 'connectors'
        },
        connectorDefaultsWidth: {
            type: Number,
            default: undefined,
            kComposite: 'connectorDefaults.width'
        }, 
        connectorDefaultsHeight: {
            type: Number,
            default: undefined,
            kComposite: 'connectorDefaults.height'
        }, 
        connectorDefaultsHoverFill: {
            type: String,
            default: undefined,
            kComposite: 'connectorDefaults.hover.fill'
        }, 
        connectorDefaultsHoverFillColor: {
            type: String,
            default: undefined,
            kComposite: 'connectorDefaults.hover.fill.color'
        }, 
        connectorDefaultsHoverFillOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'connectorDefaults.hover.fill.opacity'
        }, 
        connectorDefaultsHoverStroke: {
            type: String,
            default: undefined,
            kComposite: 'connectorDefaults.hover.stroke'
        }, 
        connectorDefaultsHoverStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'connectorDefaults.hover.stroke.color'
        }, 
        connectorDefaultsHoverStrokeDashType: {
            type: String,
            default: undefined,
            kComposite: 'connectorDefaults.hover.stroke.dashType'
        }, 
        connectorDefaultsHoverStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'connectorDefaults.hover.stroke.width'
        }, 
        connectorDefaultsFill: {
            type: String,
            default: undefined,
            kComposite: 'connectorDefaults.fill'
        }, 
        connectorDefaultsFillColor: {
            type: String,
            default: undefined,
            kComposite: 'connectorDefaults.fill.color'
        }, 
        connectorDefaultsFillOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'connectorDefaults.fill.opacity'
        }, 
        connectorDefaultsStroke: {
            type: String,
            default: undefined,
            kComposite: 'connectorDefaults.stroke'
        }, 
        connectorDefaultsStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'connectorDefaults.stroke.color'
        }, 
        connectorDefaultsStrokeDashType: {
            type: String,
            default: undefined,
            kComposite: 'connectorDefaults.stroke.dashType'
        }, 
        connectorDefaultsStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'connectorDefaults.stroke.width'
        }, 
        contentAlign: {
            type: String,
            default: undefined,
            kComposite: 'content.align'
        }, 
        contentColor: {
            type: String,
            default: undefined,
            kComposite: 'content.color'
        }, 
        contentFontFamily: {
            type: String,
            default: undefined,
            kComposite: 'content.fontFamily'
        }, 
        contentFontSize: {
            type: Number,
            default: undefined,
            kComposite: 'content.fontSize'
        }, 
        contentFontStyle: {
            type: String,
            default: undefined,
            kComposite: 'content.fontStyle'
        }, 
        contentFontWeight: {
            type: String,
            default: undefined,
            kComposite: 'content.fontWeight'
        }, 
        contentTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'content.template'
        }, 
        contentText: {
            type: String,
            default: undefined,
            kComposite: 'content.text'
        }, 
        editable: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable'
        }, 
        editableConnect: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.connect'
        }, 
        editableTools: {
            type: Array,
            default: undefined,
            kComposite: 'editable.tools'
        },
        fill: {
            type: String,
            default: undefined,
            kComposite: 'fill'
        }, 
        fillColor: {
            type: String,
            default: undefined,
            kComposite: 'fill.color'
        }, 
        fillOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'fill.opacity'
        }, 
        fillGradientType: {
            type: String,
            default: undefined,
            kComposite: 'fill.gradient.type'
        }, 
        fillGradientCenter: {
            type: Array,
            default: undefined,
            kComposite: 'fill.gradient.center'
        }, 
        fillGradientRadius: {
            type: Number,
            default: undefined,
            kComposite: 'fill.gradient.radius'
        }, 
        fillGradientStart: {
            type: Array,
            default: undefined,
            kComposite: 'fill.gradient.start'
        }, 
        fillGradientEnd: {
            type: Array,
            default: undefined,
            kComposite: 'fill.gradient.end'
        }, 
        fillGradientStops: {
            type: Array,
            default: undefined,
            kComposite: 'fill.gradient.stops'
        },
        height: {
            type: Number,
            default: undefined,
            kComposite: 'height'
        }, 
        hoverFill: {
            type: String,
            default: undefined,
            kComposite: 'hover.fill'
        }, 
        hoverFillColor: {
            type: String,
            default: undefined,
            kComposite: 'hover.fill.color'
        }, 
        hoverFillOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'hover.fill.opacity'
        }, 
        id: {
            type: String,
            default: undefined,
            kComposite: 'id'
        }, 
        minHeight: {
            type: Number,
            default: undefined,
            kComposite: 'minHeight'
        }, 
        minWidth: {
            type: Number,
            default: undefined,
            kComposite: 'minWidth'
        }, 
        path: {
            type: String,
            default: undefined,
            kComposite: 'path'
        }, 
        rotationAngle: {
            type: Number,
            default: undefined,
            kComposite: 'rotation.angle'
        }, 
        source: {
            type: String,
            default: undefined,
            kComposite: 'source'
        }, 
        strokeColor: {
            type: String,
            default: undefined,
            kComposite: 'stroke.color'
        }, 
        strokeDashType: {
            type: String,
            default: undefined,
            kComposite: 'stroke.dashType'
        }, 
        strokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'stroke.width'
        }, 
        type: {
            type: String,
            default: undefined,
            kComposite: 'type'
        }, 
        visual: {
            type: Function,
            default: undefined,
            kComposite: 'visual'
        }, 
        width: {
            type: Number,
            default: undefined,
            kComposite: 'width'
        }, 
        x: {
            type: Number,
            default: undefined,
            kComposite: 'x'
        }, 
        y: {
            type: Number,
            default: undefined,
            kComposite: 'y'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-diagram-vue-wrapper/src/KendoDiagramShape/ShapeProps.js